import styled from '@emotion/styled';
import React, { useState } from 'react';
import { HELP_ORIGIN } from '../../../constants';
import { ROUTE_SSO } from '../../../ReduxStorage/routeActions';
import { Checkbox } from '../../components/Checkbox/component';
import { ModalDialog } from '../../components/Modals/ModalDialog';
import {
  OL_COLOUR_BLACK_90,
  OL_COLOUR_NAVY_BABY,
} from '../../components/Style/colours';
import { Link } from '../Link';

export interface LearnersConsentModalProps {
  currentInstitution: Immutable.Map<'name', string> | null | undefined;
  learnerHasEnrolmentConsentPermission: boolean;
  updateLearnerHasEnrolmentConsentPermissionError: string | null;
  updateLearnerHasEnrolmentConsentPermission: () => void;
}

const CheckboxLabel = styled('div')({
  fontWeight: 400,
});

const PermissionError = styled('div')({
  color: 'red',
  marginTop: '5px',
});

const EmailPermissionLink = styled(Link)({
  marginTop: '10px',
  color: OL_COLOUR_NAVY_BABY,
  ':hover': {
    color: OL_COLOUR_NAVY_BABY,
  },
  textDecoration: 'underline',
});

const ModalBody = styled('div')({
  color: OL_COLOUR_BLACK_90,
  marginBottom: '5px',
});

const CheckboxWrapper = styled('div')({
  marginTop: '16px',
  marginLeft: '-5px',
});

export const LearnersConsentModal: React.FC<LearnersConsentModalProps> = ({
  currentInstitution,
  learnerHasEnrolmentConsentPermission,
  updateLearnerHasEnrolmentConsentPermissionError,
  updateLearnerHasEnrolmentConsentPermission,
}) => {
  const courseProviderName = currentInstitution?.get('name', '') || '';
  const [permissionConsentChecked, setPermissionConsentChecked] = useState(
    false
  );
  const [permissionCheckHasError, setPermissionCheckHasError] = useState(false);

  return (
    <ModalDialog
      show={!learnerHasEnrolmentConsentPermission}
      small
      center
      showClose={false}
      title="Permission request"
      actions={[
        {
          label: 'Continue to course',
          onClick: () => {
            if (!permissionConsentChecked) {
              setPermissionCheckHasError(true);
            } else {
              updateLearnerHasEnrolmentConsentPermission();
            }
          },
          type: 'primary-kelp',
        },
      ]}
    >
      <ModalBody>
        {courseProviderName} would like to communicate with you throughout
        and/or upon completion of this course.
        <CheckboxWrapper>
          <Checkbox
            label={
              <CheckboxLabel>
                By checking this box, you agree to share your email address with{' '}
                {courseProviderName}.
                {permissionCheckHasError && (
                  <PermissionError>
                    This permission is required to continue.
                  </PermissionError>
                )}
              </CheckboxLabel>
            }
            name="checkbox"
            onChange={() =>
              setPermissionConsentChecked(!permissionConsentChecked)
            }
            checked={permissionConsentChecked}
          />
        </CheckboxWrapper>
        <div>
          <EmailPermissionLink
            to={{
              type: ROUTE_SSO,
              params: {
                action: 'help',
              },
              query: {
                url: `${HELP_ORIGIN}/t/g9h673l/giving-email-permission-to-institutional-course-providers-on-openlearning`,
              },
            }}
            target="_blank"
          >
            Learn more about email permission
          </EmailPermissionLink>
        </div>
        {updateLearnerHasEnrolmentConsentPermissionError && (
          <PermissionError>
            {updateLearnerHasEnrolmentConsentPermissionError}
          </PermissionError>
        )}
      </ModalBody>
    </ModalDialog>
  );
};
